const getSrcValue = (currentImageAsDomElement, defaultImage) => {
  try {
    const imgEl = currentImageAsDomElement;
    if (new RegExp(`${defaultImage}$`).test(imgEl.src)) {
      return null;
    }
    return imgEl.src;
  } catch (error) {
    return null;
  }
};
export default getSrcValue;